<script>
  import { onMount } from 'svelte';
  import { format } from 'svelte-i18n';
  import { Button, Input } from '@sveltestrap/sveltestrap';

  import { Spinner } from '@client/components/spinner';

  import { PluginsService } from '@client/services/plugins';

  import { resizeIframe } from '@client/utils/iframe';

  export let plugin = null;
  export let loadingDiagnostics = false;
  export let diagnostics = null;
  export let recipientEmail = '';
  export let showDiagnostics = false;
  export let refreshDiagnostics = () => {};

  const toggleDiagnosticsOutput = () => (showDiagnostics = !showDiagnostics);
</script>

<div class="tab-content">
  {#if loadingDiagnostics}
    <div class="section">
      <div class="loading">
        <Spinner inline show />
      </div>
    </div>
  {:else if diagnostics}
    <div class="section">
      <div class="source-tour"></div>
      <h2 class="heading">{$format('label.HTML_SOURCE')}</h2>
      <pre>{diagnostics.html}</pre>
    </div>
    <div class="section">
      <h2 class="heading">{$format('label.RENDERED_HTML')}</h2>
      <div class:rendered-html={diagnostics.text}>
        <iframe
          tabindex="-1"
          style="width: 100%; visibility: hidden;"
          scrolling="no"
          title={plugin.rulename}
          on:load={resizeIframe}
          srcdoc="<html><body><div style='font-family: monospace'>{diagnostics.html}</div></body></html>"
        />
      </div>
    </div>
    <div class="section">
      <h2 class="heading">{$format('label.RENDERED_TEXT')}</h2>
      <div class:rendered-text={diagnostics.text}>{diagnostics.text}</div>
    </div>
    <div class="section">
      <h2 class="heading">{$format('label.DIAGNOSTICS')}</h2>
      {#if !showDiagnostics}
        <Input
          type="text"
          placeholder={$format('label.PLACEHOLDER.INTEGRATION_DIAGNOSTICS')}
          bind:value={recipientEmail}
        />
        <div class="diagnostics">
          <Button color="secondary" on:click={toggleDiagnosticsOutput}>
            {$format('label.INTEGRATION_SHOW_DIAGNOSTICS')}
          </Button>
          <Button color="primary" on:click={refreshDiagnostics}>{$format('label.REFRESH')}</Button>
        </div>
      {:else}
        <Input
          type="text"
          placeholder={$format('label.PLACEHOLDER.INTEGRATION_DIAGNOSTICS')}
          bind:value={recipientEmail}
        />
        <div class="diagnostics">
          <Button color="secondary" on:click={toggleDiagnosticsOutput}>
            {$format('label.INTEGRATION_HIDE_DIAGNOSTICS')}
          </Button>
          <Button color="primary" on:click={refreshDiagnostics}>{$format('label.REFRESH')}</Button>
        </div>

        {#if !diagnostics?.error}
          <pre>{JSON.stringify(diagnostics.data, null, 2)}</pre>
        {:else}
          <pre>{JSON.stringify(diagnostics.error, null, 2)}</pre>
        {/if}
      {/if}
    </div>
  {:else}
    {$format('label.NO_DIAGNOSTIC_OUTPUT')}
  {/if}
</div>

<style lang="scss" src="./diagnostics.scss"></style>
